module.exports = __webpack_public_path__ + "static/img/1.4465b15.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/home/1.jpg
// module id = 9Fgw
// module chunks = 12